'use strict';

var _timers = require('common/utils/timers');

module.exports = {
    componentDidMount: function componentDidMount() {
        this.props.app.notifier.push(this);
    },
    notify: function notify(message) {
        var _this = this;

        clearTimeout(this._updateTimer);
        this._updateTimer = (0, _timers.setTimeout)(function () {
            if (_this.isMounted()) {
                _this.forceUpdate();
            }
        }, this.props.app.testMode ? 1 : 100);
    },
    componentWillUnmount: function componentWillUnmount() {
        this.props.app.notifier.remove(this);
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/mixins/watch-app-notifier.js
 ** module id = 710
 ** module chunks = 0
 **/